import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	usesAiVerifyResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	usesAiVerifyResults: {
		id: 'jql-builder-with-ai.natural-language-to-jql-wrapper.jql-builder-embedded.uses-ai-verify-results',
		defaultMessage: 'Uses AI. Verify results.',
		description: 'Text to display for the link to AI trust page',
	},
});
